<div class="av-picker d-flex flex-column">
  <span class="av-picker__label">{{ label() | translate }}</span>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="av-picker__field">
    <input
      matInput
      type="text"
      autocomplete="off"
      [formControl]="queryControl"
      [matAutocomplete]="auto"
      [attr.aria-label]="label() | translate"
      [placeholder]="'app.reports.allDemands.filters.pickerSearch' | translate"
    />
    @if (selectedId() !== null) {
      <button
        type="button"
        matSuffix
        mat-icon-button
        class="av-picker__clear"
        [attr.aria-label]="'shared.general.buttons.remove' | translate"
        (click)="onClear()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayOption"
      (optionSelected)="onOptionSelected($event.option.value)"
      (closed)="onPanelClosed()"
    >
      <mat-option [value]="null">{{
        'app.reports.allDemands.filters.pickerAny' | translate
      }}</mat-option>
      @for (option of visibleOptions(); track option.id) {
        <mat-option [value]="option">
          <span class="av-picker__option d-flex flex-column">
            <span class="d-inline-flex align-items-center gap-1">
              <span class="av-picker__label text-truncate">{{ option.label }}</span>
              @if (option.deleted) {
                <span class="av-deleted-badge">{{
                  'shared.general.labels.deleted' | translate
                }}</span>
              }
            </span>
            @if (option.detail) {
              <span class="av-picker__detail text-truncate">{{ option.detail }}</span>
            }
          </span>
        </mat-option>
      }
      @if (placeholderKey(); as key) {
        <mat-option [disabled]="true" [value]="null">{{ key | translate }}</mat-option>
      }
    </mat-autocomplete>
    @if (hint(); as hintKey) {
      <mat-hint>{{ hintKey | translate }}</mat-hint>
    }
  </mat-form-field>
</div>
